import { DefaultTheme } from 'styled-components';
import { SislogThemeContextDefaultValue, ISislogThemeContext } from '../contexts/SislogThemeContext';

declare module 'styled-components' {
    export interface DefaultTheme extends ISislogThemeContext {
    }
}

export const theme: DefaultTheme = { ...SislogThemeContextDefaultValue }